import { render } from "./DotTyping.vue.js?vue&type=template&id=25d14cff&scoped=true!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./DotTyping.vue?vue&type=template&id=25d14cff&scoped=true"
const script = {}

import "./DotTyping.vue.scss?vue&type=style&index=0&id=25d14cff&lang=scss&scoped=true!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./DotTyping.vue?vue&type=style&index=0&id=25d14cff&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d14cff"]])

export default __exports__